<template>
    <div class="card mt-2">
        <div class="card__title">
            <h5>{{ item.tipo }}</h5>
        </div>
        <div class="card__content">
            <div v-show="item.grupos.length > 0" v-for="(proceso, index) in item.grupos" :key="index">
                <item-grupo-contenedor v-if="proceso !== null" @verImagen="verImagen" :title="proceso.grupo" :imagenes="proceso.imagenes" ></item-grupo-contenedor>
            </div>
            
            <div class="mb-2" v-if="item.grupos.length === 0">
                <strong>{{ $t('message.sinDatos') }}</strong>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        item : {
            type : Object,
            required : true
        },
        showIfNoImages : {
            type : Boolean,
            required : false,
            default : true
        }
    },
    methods :  {
        verImagen : function (imagen) {
            this.$emit('verImagen', imagen);
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/clientes/ItemContenedor.vue